import { HeadingText } from '@leagueplatform/genesis-core';

// Shared level-2 heading for Settings section cards (Communication Preferences,
// Notifications). `id` wires it to the owning group's `aria-labelledby`.
export const SectionHeading = ({
  id,
  children,
}: {
  id?: string;
  children: string;
}) => (
  <HeadingText id={id} level="2" size="sm" css={{ typography: '$headingFour' }}>
    {children}
  </HeadingText>
);
